import type { Configuration } from '../types';

export const defaultConfig: Configuration = {
  version: '2.0',

  document: {
    title: 'Document',
    author: '',
    date: 'auto',
    language: 'en-US',
    keywords: [],
    subject: '',
  },

  page: {
    format: 'A4',
    orientation: 'portrait',
    margins: {
      top: '25mm',
      right: '20mm',
      bottom: '25mm',
      left: '20mm',
    },
  },

  features: {
    toc: {
      enabled: true,
      depth: 3,
      title: 'Table of Contents',
      position: 'after-cover',
    },

    numbering: {
      headings: false,
      figures: true,
      tables: true,
      equations: true,
    },

    crossReferences: {
      enabled: false,
      prefix: {
        figure: 'Figure',
        table: 'Table',
        section: 'Section',
      },
    },

    math: {
      enabled: true,
      renderer: 'katex',
      macros: {},
    },

    diagrams: {
      mermaid: true,
      plantuml: false,
    },

    codeHighlight: {
      enabled: true,
      theme: 'github-dark',
      showLineNumbers: true,
      languages: 'auto',
    },

    callouts: {
      enabled: true,
      types: ['note', 'tip', 'warning', 'important', 'caution'],
    },

    citations: {
      enabled: false,
      style: 'apa',
      bibliography: '',
    },
  },

  theme: 'modern',
  customCSS: [],
  fonts: [],

  header: {
    enabled: false,
    template: '',
    height: '15mm',
  },

  footer: {
    enabled: false,
    template: '',
    height: '15mm',
  },

  pdf: {
    version: '1.7',
    embedFonts: true,
    compression: true,
    pdfA: false,
    pdfUA: true,
    tagged: true,
    encryption: {
      enabled: false,
      userPassword: '',
      ownerPassword: '',
      permissions: {
        print: true,
        copy: true,
        modify: false,
      },
    },
  },

  images: {
    optimize: true,
    quality: 85,
    maxWidth: 2000,
    embedRemote: true,
    cache: true,
    cacheDir: '.cache/images',
  },

  processing: {
    parallel: true,
    maxWorkers: 4,
    timeout: 60000,
  },

  output: {
    directory: './output',
    filename: '{{document.title}}.pdf',
    overwrite: true,
  },

  plugins: [],

  dev: {
    watch: true,
    liveReload: true,
    port: 3000,
    open: true,
  },

  validation: {
    markdown: {
      enabled: true,
      rules: 'default',
    },
    links: {
      checkExternal: false,
      checkInternal: true,
    },
    accessibility: {
      enabled: true,
      level: 'AA',
    },
  },

  logging: {
    level: 'info',
    file: 'mdexport.log',
    format: 'json',
  },
};
